import { useSelector } from 'react-redux';

import { currencyFormat } from 'common/helpers/numberHelper';

const UserTools = (props) => {
  const { cart, onShowCart, settings } = props;
  const isSideCartVisible = useSelector(
    (state) => state.cart.isSideCartVisible
  );

  const handleShowCart = (e) => {
    e.preventDefault();
    onShowCart();
  };
  if (!cart.items) {
    return (
      <a
        href="#"
        role="button"
        onClick={handleShowCart}
        aria-label={`Shopping cart, contains 0 items, ${currencyFormat(
          0,
          settings
        )}`}
        aria-controls="c7-side-cart"
        aria-expanded={isSideCartVisible}
      >
        {' '}
        <span className="c7-cart__count">0</span>{' '}
        <span className="c7-cart__total">{currencyFormat(0, settings)}</span>
      </a>
    );
  }
  const itemCount = cart.items.reduce(
    (total, item) => total + item.quantity,
    0
  );
  return (
    <a
      href="#"
      role="button"
      onClick={handleShowCart}
      aria-label={`Shopping cart, contains ${itemCount} items, ${currencyFormat(
        cart.total,
        settings
      )}`}
      aria-controls="c7-side-cart"
      aria-expanded={isSideCartVisible}
    >
      {' '}
      <span className="c7-cart__count">{itemCount}</span>{' '}
      <span className="c7-cart__total">
        {currencyFormat(cart.total, settings)}
      </span>
    </a>
  );
};

export default UserTools;
